import React from "react";
import { type RouteObject } from "react-router-dom";
import { PublicRoute } from "./RouteGuards";

const HomePage = React.lazy(() => import("@/Home/infraestructure/pages/Home"));
const TermsOfUsePage = React.lazy(() => import("@/Home/infraestructure/pages/TermsOfUse"));
const TermsNexiaPage = React.lazy(() => import("@/Home/infraestructure/pages/TermsNexia"));
const PrivacyPolicyPage = React.lazy(() => import("@/Home/infraestructure/pages/PrivacyPolicy"));

export const publicRoutes: RouteObject[] = [
  {
    path: "/welcome",
    element: (
      <PublicRoute>
        <HomePage />
      </PublicRoute>
    ),
  },
  {
    path: "/terms-of-use",
    element: (
      <PublicRoute>
        <TermsOfUsePage />
      </PublicRoute>
    ),
  },
  {
    path: "/terms-nexia",
    element: (
      <PublicRoute>
        <TermsNexiaPage />
      </PublicRoute>
    ),
  },
  {
    path: "/privacy-policy",
    element: (
      <PublicRoute>
        <PrivacyPolicyPage />
      </PublicRoute>
    ),
  },
];
